<template>
  <div class="flex justify-center flex-col">
    <img alt="LOGO" class="object-contain h-12" :src="props.logoImage" />
    <div class="flex justify-center text-xs mt-4 mb-2 tracking-tighter" :class="props.textColor">{{ props.version }}</div>
  </div>
</template>

<script setup>
const props = defineProps({
  logoImage: {
    type: String
  },
  version: {
    type: String
  },
  textColor: {
    type: String
  }
});
</script>
